<div class="ant-table-filter-dropdown">
	<div class="search-box">
		<input type="text" class="search-input" nz-input autofocus
			placeholder="Search name"
			[(ngModel)]="searchValue" 
			(keyup.enter)="searchValue ? search() : false"
		/>
		<button nz-button nzType="primary" class="search-button" 
			[disabled]="!searchValue"
			(click)="search()"
		>Search</button>
		<button nz-button class="search-reset-btn" 
			[disabled]="!tableSearchValue" 
			(click)="reset()"
		>Reset</button>
	</div>
</div>